const API_CONFIG = {
    baseURL: process.env.REACT_APP_API_BASE_URL || '/api',
    timeout: 10000,
};

console.log('API Base URL:', API_CONFIG.baseURL); // For debugging

export default API_CONFIG;
